import React from "react";
import { Box, Stack, Title, Detail, constants } from "@thecb/components";

const { FONT_WEIGHT_SEMIBOLD } = constants.styleConstants;

const TitleModule = ({ title, subtitle, titleColor, subtitleColor }) => (
  <Box padding="0">
    <Stack childGap="0">
      <Title
        variant="small"
        weight={FONT_WEIGHT_SEMIBOLD}
        color={titleColor}
        as="h3"
        id="obligation-title"
      >
        {title}
      </Title>
      <Detail
        variant="small"
        color={subtitleColor}
        as="p"
        id="obligation-subtitle"
      >
        {subtitle}
      </Detail>
    </Stack>
  </Box>
);

export default TitleModule;
